// Copyright (c) 2025 GeoVerses. All rights reserved.

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCd49V3Rq0TG0dCZjLtVBHRZyt1DPKxFzA",
    authDomain: "geoverses-a9016.firebaseapp.com",
    projectId: "geoverses-a9016",
    storageBucket: "geoverses-a9016.firebasestorage.app",
    messagingSenderId: "140638428445",
    appId: "1:140638428445:web:6058527dce67974c8c55f4",
    measurementId: "G-VPSVBY6BXV"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword };
